import { render } from "./tree-menu-item.vue?vue&type=template&id=14967a3a&scoped=true"
import script from "./tree-menu-item.vue?vue&type=script&lang=js"
export * from "./tree-menu-item.vue?vue&type=script&lang=js"

import "./tree-menu-item.vue?vue&type=style&index=0&id=14967a3a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14967a3a"]])

export default __exports__